// @flow

// skipping story doc for this component as it is intended to be used alongside NavigableList
/* eslint-disable ta-code-conventions/has-matching-storydoc */

import * as React from 'react';

import KeyboardEventListener from '@ta/events.keyboard-event-listener';

type Props = {|
  /** An optional callback if a result is selected */
  onSelection?: (event: SyntheticEvent<HTMLElement> | KeyboardEvent) => void,

  /** An optional callback for if/when the mouse moves over the result */
  onMouseMove?: (event: SyntheticMouseEvent<HTMLElement>) => mixed,

  /** If this list item is currently active */
  active?: boolean,

  children?: React.Node,
|};

class NavigableListItem extends React.Component<Props> {
  static defaultProps = {
    onSelection: undefined,
    children: undefined,
  };

  onEnter = (e: KeyboardEvent) => {
    if (this.props.active && this.props.onSelection) {
      this.props.onSelection(e);
    }
  };

  render() {
    return (
      <div onClick={this.props.onSelection} onMouseMove={this.props.onMouseMove}>
        {this.props.children}
        <KeyboardEventListener keyName="Enter" callback={this.onEnter} />
      </div>
    );
  }
}

export default NavigableListItem;
